import moment from 'moment-jalaali';
import { isAppLang } from './getEnv';

if (isAppLang('fa')) {
  moment.loadPersian({
    dialect: 'persian-modern',
  });
}

moment.relativeTimeThreshold('m', 60);
moment.relativeTimeThreshold('h', 25);

export { moment };
